"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Phone32 = function (props) { return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    react_1.default.createElement("path", { d: "M7.048 7.822c-.188 2.791.004 6.779 3.811 11.91 3.808 5.133 7.702 6.45 10.481 7.146 2.777.698 4.623-1.53 4.764-2.382.329-2.537-.736-2.386-3.335-3.811-2.598-1.424-2.4-1.086-3.334-.476-.936.608-1.502.267-1.906 0-.404-.27-2.616-1.846-3.4-2.9-.78-1.05-2.183-3.312-2.317-3.77-.134-.457.067-1.23.953-1.906.887-.675 1.636-.68 1.06-3.533-.572-2.853-.39-3.599-2.966-4.089-.87-.138-3.618 1.019-3.81 3.811zm-.998-.067c.2-2.903 3.02-5.04 4.996-4.726 2.302.438 3.032 1.187 3.46 3.309.04.196.233 1.234.3 1.564.477 2.365.2 3.394-.988 4.216l-.24.164a4.758 4.758 0 00-.207.147c-.482.367-.632.716-.6.829.087.293 1.429 2.47 2.161 3.455.282.38.884.937 1.663 1.558a26 26 0 001.485 1.103c.356.236.426.245.809-.003.043-.028.517-.372.69-.466.888-.48 1.526-.272 3.671.903.509.28 2.009 1.007 2.273 1.157 1.379.782 1.818 1.769 1.568 3.694-.322 1.948-3.133 3.908-5.994 3.19-4.429-1.11-7.724-3.05-11.04-7.521C6.712 15.822 5.76 12.042 6.05 7.755z", className: "phone-32_svg__path-1" }))); };
var StyledPhone32 = styled_components_1.default(Phone32)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"], ["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"])), function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var stroke = _a.stroke;
    return stroke && "stroke: " + stroke + "; stroke-width: 64;";
});
exports.default = StyledPhone32;
var templateObject_1;
//# sourceMappingURL=Phone32.js.map